import type { ComponentCommonDownloadableContentList } from '@edwin-group/people-graphql';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

function DownloadableContent({
  component,
  className,
  isDefaultContentTemplate = false,
  title,
}: {
  component?: ComponentCommonDownloadableContentList;
  className?: string;
  title?: string;
  isDefaultContentTemplate?: boolean;
}) {
  if (component?.list?.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames('rounded-sh-16 border border-people-green-100 bg-white p-4', className, {
        'mt-0': isDefaultContentTemplate,
        'mt-sh-30': !isDefaultContentTemplate,
      })}>
      <h2
        className={classNames('mb-2 font-haffer text-sh-14-20 font-bold text-black', {
          'mt-0': isDefaultContentTemplate,
        })}>
        {title || 'Downloads'}
      </h2>
      <ul key="downloadable" className="downloadable-list m-0 !mb-0 !mt-2 flex list-none flex-col gap-2 p-0">
        {component?.list?.map((c) => (
          <li key={c?.id} className="flex flex-col gap-0 pl-0 [list-style:none]">
            <a
              href={c!.content!.data!.attributes!.url!}
              rel="noreferrer"
              target="_blank"
              className="flex items-center gap-2 font-haffer text-sh-14-20 font-normal text-dark-grey no-underline hover:underline">
              <ArrowDownTrayIcon className="h-5 w-5 shrink-0 text-download-icon" aria-hidden />
              <span>{c?.title}</span>
            </a>
            {c?.description ? (
              <p className="ml-7 font-haffer text-sh-14-20 font-normal text-dark-grey">{c.description}</p>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DownloadableContent;
